module.exports = __webpack_public_path__ + "img/icone-entrar.51d7c020.svg";